const routes = [
    {
        path: "/assessment/types",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "assessmenttype_index"
        }
    }
];

export default routes;
